module.exports = __webpack_public_path__ + "img/senha.3d687dc7.svg";